import type {
  DateRangeTabListPresetMap,
  PeriodUnitListPresetMap,
} from './type';

export const PERIOD_UNIT_LIST_PRESET: PeriodUnitListPresetMap = Object.freeze({
  en: [
    { label: 'Day', value: 'day' },
    { label: 'Week', value: 'week' },
    { label: 'Month', value: 'month' },
    { label: 'Year', value: 'year' },
  ],
  ko: [
    { label: '일', value: 'day' },
    { label: '주', value: 'week' },
    { label: '개월', value: 'month' },
    { label: '년', value: 'year' },
  ],
});

export const DATE_RANGE_TAB_LIST_PRESET: DateRangeTabListPresetMap =
  Object.freeze({
    en: {
      minute: [
        {
          label: 'Recnet 24H',
          value: 24,
          unit: 'hour',
        },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
      hour: [
        { label: 'Recnet 24H', value: 24, unit: 'hour' },
        { label: 'Recnet 48H', value: 48, unit: 'hour' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
      day: [
        { label: 'Recnet 15D', value: 15, unit: 'day' },
        { label: 'Recnet 30D', value: 30, unit: 'day' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
      week: [
        { label: 'Recnet 4W', value: 4, unit: 'week' },
        { label: 'Recnet 8W', value: 8, unit: 'week' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
      month: [
        { label: 'Recnet 6M', value: 6, unit: 'month' },
        { label: 'Recnet 1Y', value: 12, unit: 'month' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
      year: [
        { label: 'Recnet 1Y', value: 1, unit: 'year' },
        { label: 'Recnet 2Y', value: 2, unit: 'year' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
    },
    ko: {
      minute: [
        { label: '최근 24시간', value: 24, unit: 'hour' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
      hour: [
        { label: '최근 24시간', value: 24, unit: 'hour' },
        { label: '최근 48시간', value: 48, unit: 'hour' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
      day: [
        { label: '최근 15일', value: 15, unit: 'day' },
        { label: '최근 30일', value: 30, unit: 'day' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
      week: [
        { label: '최근 4주', value: 4, unit: 'week' },
        { label: '최근 8주', value: 8, unit: 'week' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
      month: [
        { label: '최근 6개월', value: 6, unit: 'month' },
        { label: '최근 1년', value: 12, unit: 'month' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
      year: [
        { label: '최근 1년', value: 1, unit: 'year' },
        { label: '최근 2년', value: 2, unit: 'year' },
        { label: 'custom', value: 0, unit: 'custom' },
      ],
    },
  });
